"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.QUOTE_CASSI_PATH = exports.REPORTS_PATH = exports.ROLE_MANAGEMENT = exports.APPROVAL_DESK = exports.PRODUCTS_PATH_2 = exports.PRODUCTS_PATH = exports.USER_ACCESS_CONTROL = exports.INVOICE_GROUP_PATH_2 = exports.TRANSACTION_ACCOUNT_BALANCE_PATH_2 = exports.TRANSACTION_ACCOUNT_PATH_2 = exports.SUPPORT_ISSUE_PATH_SMART_AC = exports.SUPPORT_ISSUE_PATH = exports.REFUND_PATH_2 = exports.REFUND_PATH = exports.QUOTE_PATH_2 = exports.QUOTE_PATH = exports.PARTNER_ACCOUNT_PATH = exports.ORGANIZATION_PATH_2 = exports.ORGANIZATION_PATH = exports.INVOICE_PATH_2 = exports.INVOICE_PATH = exports.EMAIL_PATH = exports.DOMAIN_PATH = exports.CONTACT_PATH_2 = exports.CONTACT_PATH = exports.UNAUTHORIZED_PATH = exports.NOT_FOUND_PATH = exports.GENERIC_ERROR_PATH = exports.ADD_ON_PANEL_PATH = exports.ORDER_PATH = exports.SEARCH_PATH_V2 = exports.SEARCH_PATH = exports.CCP_ENTITLEMENT_PATH_2 = exports.CCP_ENTITLEMENT_PATH = exports.STATUSPAGE_ADDONS_PATH_2 = exports.STATUSPAGE_ADDONS_PATH = exports.OPSGENIE_PATH = exports.TRELLO_PATH = exports.STATUSPAGE_PATH_2 = exports.STATUSPAGE_PATH = exports.SERVICE_LICENSE_PATH = exports.SERVER_LICENSE_PATH = exports.GENERIC_ENTITLEMENT_PATH = exports.CLOUD_SITE_PATH_2 = exports.CLOUD_SITE_PATH = exports.BITBUCKET_PATH = exports.ATLASSIAN_ACCESS_PATH = exports.CASSI_ADMIN_PATH = exports.CASSI_APPS_PREFIX = exports.CASSI_UI_PREFIX = void 0;
exports.USER_ACCESS_CONTROL_V2 = exports.CREDIT_DETAILS = void 0;
// CASSI UI Routes - Used for building links to the pages
exports.CASSI_UI_PREFIX = '/ui';
exports.CASSI_APPS_PREFIX = '/apps';
// Special routes
exports.CASSI_ADMIN_PATH = '/admin';
// Entitlements
exports.ATLASSIAN_ACCESS_PATH = '/atlassian-access';
exports.BITBUCKET_PATH = '/bitbucket';
exports.CLOUD_SITE_PATH = '/cloud-sites';
exports.CLOUD_SITE_PATH_2 = '/cloud-sites/v2';
exports.GENERIC_ENTITLEMENT_PATH = '/entitlements';
exports.SERVER_LICENSE_PATH = '/licenses';
exports.SERVICE_LICENSE_PATH = '/services';
exports.STATUSPAGE_PATH = '/entitlements/ccp';
exports.STATUSPAGE_PATH_2 = '/entitlements/ccp/v2';
exports.TRELLO_PATH = '/trello';
exports.OPSGENIE_PATH = '/opsgenie';
exports.STATUSPAGE_ADDONS_PATH = '/statuspage/add-ons';
exports.STATUSPAGE_ADDONS_PATH_2 = '/statuspage/add-ons/v2';
exports.CCP_ENTITLEMENT_PATH = '/entitlements/ccp';
exports.CCP_ENTITLEMENT_PATH_2 = '/entitlements/ccp/v2';
exports.SEARCH_PATH = '/search';
exports.SEARCH_PATH_V2 = '/';
// Orders
exports.ORDER_PATH = '/orders/v1';
// Add On Panel
exports.ADD_ON_PANEL_PATH = '/addon';
// Error pages
exports.GENERIC_ERROR_PATH = '/error';
exports.NOT_FOUND_PATH = '/not-found';
exports.UNAUTHORIZED_PATH = '/unauthorized';
// Other
exports.CONTACT_PATH = '/contacts';
exports.CONTACT_PATH_2 = '/contacts/v2';
exports.DOMAIN_PATH = '/domains';
exports.EMAIL_PATH = '/emails';
exports.INVOICE_PATH = '/invoices';
exports.INVOICE_PATH_2 = '/invoices/v2';
exports.ORGANIZATION_PATH = '/organization';
exports.ORGANIZATION_PATH_2 = '/organization/v2';
exports.PARTNER_ACCOUNT_PATH = '/partner-accounts';
exports.QUOTE_PATH = '/quotes';
exports.QUOTE_PATH_2 = '/quotes/v2';
exports.REFUND_PATH = '/refunds';
exports.REFUND_PATH_2 = '/refunds/v2';
exports.SUPPORT_ISSUE_PATH = '/support-issues';
exports.SUPPORT_ISSUE_PATH_SMART_AC = '/support-ticket';
exports.TRANSACTION_ACCOUNT_PATH_2 = '/transaction-account/v2';
exports.TRANSACTION_ACCOUNT_BALANCE_PATH_2 = '/transaction-account/account-balance/v2';
exports.INVOICE_GROUP_PATH_2 = '/invoice-group/v2';
exports.USER_ACCESS_CONTROL = '/user-access-control';
exports.PRODUCTS_PATH = '/products';
exports.PRODUCTS_PATH_2 = '/products/v2';
exports.APPROVAL_DESK = '/approval-desk';
exports.ROLE_MANAGEMENT = '/role-management';
exports.REPORTS_PATH = '/reports';
exports.QUOTE_CASSI_PATH = '/quotes/v1';
// Credit Management term details route
exports.CREDIT_DETAILS = '/transaction-account/credit-details/v2';
exports.USER_ACCESS_CONTROL_V2 = '/v2/user-access-control';
